import React, { FC } from 'react';
import { StyledMask, StyledLabel } from './style';
import { MaskOverlayProps } from './types';

const MaskOverlay: FC<MaskOverlayProps> = ({ borderRadius, label }) => {
  return (
    <StyledMask borderRadius={borderRadius}>
      {label && <StyledLabel>{label}</StyledLabel>}
    </StyledMask>
  );
};

export default MaskOverlay;
